import { Box, Grid, Stack, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/app/hooks';
import BottomHeader from './Bottom';
import GroupObjectRetail from '../../GroupObjectRetail';
import ModalManageObjectRetail from '../../ModalManageObjectRetail';
import ObjectPreviewRetail from '../../ObjectPreviewRetail';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: white;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: #F5F5F5;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderSocialMediaStreamRetail() {
  const objectListByObjectType = useAppSelector(
    (state) => state.objectManagement.objectListByObjectType
  );

  const theme = useTheme();
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <HeaderWrapper display="flex" alignItems="center">
        <Grid container>
          <Grid item lg={12}>
            <Box mt={2}>
              <GroupObjectRetail />
            </Box>
          </Grid>
          <Grid item lg={12}>
            <Stack
              direction={matchesUpSm ? 'row' : 'column'}
              alignItems={matchesUpSm ? 'center' : 'start'}
              spacing={1}
              mt={1.5}
              mb={3}
            >
              <ModalManageObjectRetail title="Social Profile" />
              <ObjectPreviewRetail objectList={objectListByObjectType} />
            </Stack>
          </Grid>
        </Grid>
      </HeaderWrapper>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item lg={12}>
            <BottomHeader />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
}

export default HeaderSocialMediaStreamRetail;
